import { IGetArquivoAuditoriaUseCase } from "../../../presentation/useCases/read/get_arquivo_auditoria_use_case";
import { IAuditorRepository } from "../../repositories/auditor_repository";

export class GetArquivoAuditoriaUseCase implements IGetArquivoAuditoriaUseCase {
  constructor(private readonly repository: IAuditorRepository) {}

  async getArquivoAuditoria(
    idAuditoria: number,
    imagePosition: number,
    imageName: string,
  ): Promise<void> {
    const blob = await this.repository.getArquivoAuditoria(idAuditoria, imagePosition);

    if (!blob) throw new Error("Falha ao buscar dados da imagem!");

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", String(imageName));
    document.body.appendChild(link);
    link.click();

    link.remove();
    window.URL.revokeObjectURL(url);
  }
}
